// components/Comments/CommentForm.jsx
import { useState } from 'react';
import {
  Box, Stack, InputBase, IconButton,
  CircularProgress, Tooltip, Typography
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const MAX_LEN = 1500;

export default function CommentForm({ onSubmit }) {
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (!content.trim()) return alert('내용을 입력하세요!');
    setSending(true);
    try {
      await onSubmit(content.trim());
      setContent('');
    } catch {
      alert('댓글 작성에 실패했습니다.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Box
      component="fieldset"
      sx={{
        borderColor: 'grey.400',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 1.5,
        p: { xs: 1.5, sm: 2 },
        mt: 3,
        backgroundColor: 'background.paper',
      }}
    >
      <Typography
        component="legend"
        variant="subtitle1"
        sx={{ px: 1, fontWeight: 'bold' }}
      >
        댓글 작성
      </Typography>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems="flex-end"
        sx={{ mt: 1 }}
      >
        <InputBase
          multiline
          fullWidth
          minRows={3}
          maxRows={6}
          value={content}
          placeholder="댓글을 입력하세요…"
          onChange={(e) => {
            if (e.target.value.length <= MAX_LEN) {
              setContent(e.target.value);
            }
          }}
          onKeyDown={(e) => {
            if (e.ctrlKey && e.key === 'Enter') handleSubmit();
          }}
          sx={{
            px: { xs: 1.5, sm: 2 },
            py: { xs: 1, sm: 1.5 },
            borderRadius: 1,
            backgroundColor: 'grey.100',
          }}
        />

        {sending ? (
          <CircularProgress
            size={24}
            sx={{ mx: 1.5, my: { xs: 0.5, sm: 1 } }}
          />
        ) : (
          <Tooltip title="Ctrl + Enter">
            <span>
              <IconButton
                color="primary"
                onClick={handleSubmit}
                disabled={!content.trim()}
                aria-label="comment submit"
                sx={{
                  alignSelf: { xs: 'flex-end', sm: 'center' },
                  mb: { xs: 0.5, sm: 0 },
                }}
              >
                <SendIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Stack>

      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'right',
          mt: 0.5,
          mr: 0.5,
          color: content.length === MAX_LEN ? 'error.main' : 'text.secondary',
        }}
      >
        {content.length}/{MAX_LEN}
      </Typography>
    </Box>
  );
}

CommentForm.defaultProps = {
  onSubmit: async (text) => {
    return new Promise((res) => setTimeout(res, 500));
  },
};
